import type { Component } from "../lib/api";
import { StatusPill } from "./StatusPill";

export function ComponentGrid({
  title,
  components,
  renderExtras,
}: {
  title: string;
  components: Component[];
  /** Optional slot rendered below each tile - used to paint the
      90-day uptime bar row under each component in PublicHome. */
  renderExtras?: (c: Component) => React.ReactNode;
}) {
  if (components.length === 0) return null;
  return (
    <section aria-labelledby={`group-${title}`} className="mt-8">
      <h2 id={`group-${title}`} className="text-lg font-semibold">
        {title}
      </h2>
      <ul className="mt-3 divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white">
        {components.map((c) => (
          <li key={c.component_id} className="px-4 py-3">
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="font-medium">{c.name}</div>
                {c.description ? (
                  <div className="text-sm text-slate-600">{c.description}</div>
                ) : null}
                {c.status !== "operational" && c.status_reason ? (
                  <div className="mt-1 text-xs text-slate-500">
                    {c.status_reason}
                  </div>
                ) : null}
              </div>
              <div className="flex shrink-0 items-center gap-3">
                <StatusPill status={c.status} />
                <a
                  className="text-xs text-blue-600 hover:underline"
                  href={`/v1/feed/component/${c.component_id}.xml`}
                  aria-label={`Atom feed for ${c.name}`}
                >
                  feed
                </a>
              </div>
            </div>
            {renderExtras ? renderExtras(c) : null}
          </li>
        ))}
      </ul>
    </section>
  );
}
